var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from '../../styles/Bar.module.scss';
var Bar = function (_a) {
    var winNumber = _a.winNumber, count = _a.count, max = _a.max, mostRecentWinNumber = _a.mostRecentWinNumber;
    var backgroundColor = '#86a579';
    var active = "".concat(mostRecentWinNumber) === winNumber;
    if (!max)
        max = 1;
    return (_jsxs("div", __assign({ className: styles.barOuter }, { children: [winNumber, _jsxs("div", __assign({ className: styles.secondaryContainer }, { children: [_jsx("div", __assign({ className: styles.growingBar, style: active ? { backgroundColor: backgroundColor, flexGrow: count / max } : { flexGrow: count / max } }, { children: count }), void 0), _jsx("div", { style: { flexGrow: 1 - count / max } }, void 0)] }), void 0)] }), void 0));
};
export default Bar;
